import {
  armarOfertas,
  cantidadPorDefecto,
  cuerpoAtribucion,
  formatearQuetzales,
  municipiosDe,
  normalizarUrlServidor,
  recordarAtribucion,
  validarFormulario,
} from "./pedido-logica.js";

const MENSAJE_SERVIDOR_NO_CONFIGURADO =
  "No pudimos conectar con nuestro sistema de pedidos. Por favor escríbanos por WhatsApp para completar su compra.";

// Píxel de Meta de la tienda (el mismo que usan las campañas para las compras).
const PIXEL_META = "1134894869040568";

const dialogo = document.getElementById("sv-pedido");
if (dialogo) iniciar();

function iniciar() {
  const form = document.getElementById("sv-form");
  const datos = JSON.parse(document.getElementById("sv-datos-producto").textContent);
  const urlWorker = normalizarUrlServidor(dialogo.dataset.worker);
  const ofertas = armarOfertas(datos);
  let departamentos = [];
  let cargandoCobertura = false;
  let cantidad = cantidadPorDefecto(ofertas);

  // De qué anuncio viene la persona: se recuerda 7 días por si vuelve después a comprar.
  const atribucion = recordarAtribucion(almacenLocal(), location.search, Date.now());

  pintarOfertas();
  pintarResumen();

  document.querySelectorAll("[data-sv-abrir]").forEach((b) =>
    b.addEventListener("click", () => {
      // <dialog>.showModal() no existe en iOS anterior a 15.4: sin este
      // respaldo, el único botón de compra no hace nada en esos celulares.
      if (typeof dialogo.showModal === "function") dialogo.showModal();
      else dialogo.setAttribute("open", "");
      if (departamentos.length === 0 && !cargandoCobertura) cargarCobertura();
      avisarApertura();
    }),
  );
  dialogo.querySelector("[data-sv-cerrar]").addEventListener("click", () => {
    if (typeof dialogo.close === "function") dialogo.close();
    else dialogo.removeAttribute("open");
  });

  const selDepartamento = document.getElementById("sv-departamento");

  // Si la carga de cobertura falló, reintentar al enfocar el select de
  // departamento (además del reintento al enviar, más abajo) para que la
  // ayuda "cierre y vuelva a abrir" nunca sea la única forma de recuperarse.
  selDepartamento.addEventListener("focus", () => {
    if (departamentos.length === 0 && !cargandoCobertura) cargarCobertura();
  });

  selDepartamento.addEventListener("change", (e) => {
    const sel = document.getElementById("sv-municipio");
    const lista = municipiosDe(departamentos, e.target.value);
    sel.innerHTML = '<option value="">Elija su municipio</option>';
    for (const m of lista) sel.add(new Option(m, m));
    sel.disabled = lista.length === 0;
  });

  form.addEventListener("submit", enviar);

  // Le avisa a Meta que alguien abrió el formulario ("InitiateCheckout"), una
  // sola vez por visita a la página, para ver cuántos lo abren y cuántos
  // terminan (la compra la avisa el servidor). Nunca debe frenar el formulario.
  // Los datos se arman aquí y no en pedido-logica.js: ese archivo se carga sin
  // versión en la dirección, y si el navegador tiene uno viejo sin la función,
  // el import fallaría y el botón de compra dejaría de funcionar.
  let aperturaAvisada = false;
  function avisarApertura() {
    if (aperturaAvisada) return;
    aperturaAvisada = true;
    try {
      const o = ofertas.find((x) => x.cantidad === cantidad);
      if (!o) return;
      pixelMeta(PIXEL_META)("trackSingle", PIXEL_META, "InitiateCheckout", {
        value: o.total / 100,
        currency: "GTQ",
        num_items: o.cantidad,
        content_name: datos.titulo,
      });
    } catch {
      // Sin aviso el pedido sigue igual.
    }
  }

  function pintarOfertas() {
    const caja = document.getElementById("sv-lista-ofertas");
    caja.innerHTML = "";
    for (const o of ofertas) {
      const etiqueta = document.createElement("label");
      etiqueta.className = "sv-oferta";
      etiqueta.innerHTML = `
        <input type="radio" name="cantidad" value="${o.cantidad}" aria-describedby="sv-error-cantidad" ${o.cantidad === cantidad ? "checked" : ""}>
        <span class="sv-oferta-nombre">${o.etiqueta}</span>
        <span class="sv-oferta-total">${formatearQuetzales(o.total)}</span>
        <span class="sv-oferta-detalle">
          <span class="sv-oferta-unitario">${formatearQuetzales(o.unitario)} cada una</span>
          ${o.ahorro > 0 ? `<span class="sv-oferta-ahorro">Ahorra ${formatearQuetzales(o.ahorro)}</span>` : ""}
        </span>`;
      const fotos = fotosOferta(o.cantidad);
      if (fotos) etiqueta.querySelector("input").after(fotos);
      etiqueta.querySelector("input").addEventListener("change", () => {
        cantidad = o.cantidad;
        pintarResumen();
      });
      caja.appendChild(etiqueta);
    }
  }

  // Tantos frascos como unidades, con la foto principal del producto. Se arma
  // con el DOM y no dentro del innerHTML de arriba para que la dirección de la
  // imagen nunca rompa el marcado. Las fotos son decoración: el texto ya dice
  // cuántas unidades son.
  function fotosOferta(unidades) {
    if (typeof datos.imagen !== "string" || datos.imagen === "") return null;
    const fotos = document.createElement("span");
    fotos.className = "sv-oferta-fotos";
    fotos.dataset.fotos = String(unidades);
    fotos.setAttribute("aria-hidden", "true");
    for (let i = 0; i < unidades; i++) {
      const img = document.createElement("img");
      img.src = datos.imagen;
      img.alt = "";
      img.width = 240;
      img.height = 240;
      fotos.appendChild(img);
    }
    return fotos;
  }

  function pintarResumen() {
    const o = ofertas.find((x) => x.cantidad === cantidad);
    if (!o) return;
    const caja = document.getElementById("sv-resumen");
    caja.innerHTML = `
      <div class="sv-resumen-fila"><span data-sv-resumen-titulo></span><span>${formatearQuetzales(o.total)}</span></div>
      <div class="sv-resumen-fila"><span>Envío</span><span class="sv-gratis">GRATIS</span></div>
      <div class="sv-resumen-fila sv-resumen-total"><span>Total a pagar al recibir</span><span>${formatearQuetzales(o.total)}</span></div>`;
    // datos.titulo es el título del producto (lo controla quien administra
    // la tienda, no un cliente), pero se pinta con textContent y no dentro
    // del innerHTML de arriba para que un "&" o "<" en el título nunca
    // rompan el marcado.
    caja.querySelector("[data-sv-resumen-titulo]").textContent = `${datos.titulo} × ${o.cantidad}`;
    document.getElementById("sv-confirmar").textContent = `Confirmar pedido – ${formatearQuetzales(o.total)}`;
  }

  async function cargarCobertura() {
    if (!urlWorker) {
      mostrarErrores({ general: MENSAJE_SERVIDOR_NO_CONFIGURADO });
      return;
    }
    cargandoCobertura = true;
    try {
      const res = await fetch(`${urlWorker}/api/cobertura`);
      if (!res.ok) throw new Error(String(res.status));
      departamentos = (await res.json()).departamentos;
      const sel = document.getElementById("sv-departamento");
      sel.innerHTML = '<option value="">Elija su departamento</option>';
      for (const d of departamentos) sel.add(new Option(d.nombre, d.codigo));
    } catch {
      departamentos = [];
      mostrarErrores({
        general: "No pudimos cargar la lista de lugares. Cierre y vuelva a abrir el formulario para intentarlo de nuevo.",
      });
    } finally {
      cargandoCobertura = false;
    }
  }

  function valoresActuales() {
    const fd = new FormData(form);
    return {
      cantidad,
      nombre: fd.get("nombre") ?? "",
      telefono: fd.get("telefono") ?? "",
      departamento: fd.get("departamento") ?? "",
      municipio: fd.get("municipio") ?? "",
      direccion: fd.get("direccion") ?? "",
      referencias: fd.get("referencias") ?? "",
      sitioWeb: fd.get("sitioWeb") ?? "",
    };
  }

  function limpiarErrores() {
    form.querySelectorAll("[data-sv-error]").forEach((p) => (p.textContent = ""));
    form.querySelectorAll("[data-invalido]").forEach((c) => {
      c.removeAttribute("data-invalido");
      const campo = c.querySelector("input, select");
      if (campo) campo.removeAttribute("aria-invalid");
    });
  }

  function mostrarErrores(errores) {
    limpiarErrores();
    let primero = null;
    const sinParrafo = [];

    for (const [campo, mensaje] of Object.entries(errores)) {
      if (campo === "general") continue;
      const p = form.querySelector(`[data-sv-error="${campo}"]`);
      if (!p) {
        // Campo que el servidor puede enviar pero que este formulario no
        // tiene marcado con [data-sv-error] (p. ej. variantId, o uno nuevo
        // que el servidor agregue más adelante): no debe perderse en
        // silencio, así que se junta con el mensaje general.
        sinParrafo.push(mensaje);
        continue;
      }
      p.textContent = mensaje;
      const caja = p.closest(".sv-campo");
      if (caja) {
        caja.setAttribute("data-invalido", "");
        const entrada = caja.querySelector("input, select");
        if (entrada) entrada.setAttribute("aria-invalid", "true");
      }
      if (!primero) primero = caja ?? p;
    }

    const mensajesGenerales = [errores.general, ...sinParrafo].filter(Boolean);
    if (mensajesGenerales.length > 0) {
      const general = form.querySelector('[data-sv-error="general"]');
      general.textContent = mensajesGenerales.join(" ");
      if (!primero) primero = general;
    }

    if (primero) primero.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  async function enviar(evento) {
    evento.preventDefault();

    if (!urlWorker) {
      mostrarErrores({ general: MENSAJE_SERVIDOR_NO_CONFIGURADO });
      return;
    }

    if (!datos.variantId) {
      mostrarErrores({
        general: "Este producto ya no está disponible. Por favor recargue la página o escríbanos por WhatsApp.",
      });
      return;
    }

    // Si la carga de cobertura había fallado, reintentar aquí en vez de
    // dejar que la validación de abajo borre la ayuda ("cierre y vuelva a
    // abrir…") y la reemplace por "Elija su departamento" sobre un select
    // vacío, sin ninguna pista de qué pasó ni cómo seguir.
    if (departamentos.length === 0 && !cargandoCobertura) {
      await cargarCobertura();
      if (departamentos.length === 0) return;
    }

    const valores = valoresActuales();
    const errores = validarFormulario(valores, departamentos);
    if (Object.keys(errores).length > 0) return mostrarErrores(errores);

    limpiarErrores();
    const boton = document.getElementById("sv-confirmar");
    boton.disabled = true;
    const textoPrevio = boton.textContent;
    boton.textContent = "Enviando…";

    try {
      const res = await fetch(`${urlWorker}/api/pedidos`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...valores,
          variantId: datos.variantId,
          telefono: String(valores.telefono).replace(/[\s-]/g, ""),
          atribucion: atribucionSegura(atribucion),
        }),
      });
      const cuerpo = await res.json().catch(() => ({}));

      // 200 y 201 son ambos éxito: el servidor responde 200 cuando el
      // pedido ya existía (mismo cliente reintentando, o dos solicitudes
      // que llegaron casi juntas) para no duplicar el pedido ni el aviso
      // por WhatsApp. En ambos casos el cuerpo trae la misma forma.
      if (res.ok && typeof cuerpo.referencia === "string" && cuerpo.referencia !== "") {
        const parametros = { ref: cuerpo.referencia, wa: cuerpo.whatsappEnviado ? "1" : "0" };
        if (typeof cuerpo.total === "string" && cuerpo.total !== "") parametros.total = cuerpo.total;
        const q = new URLSearchParams(parametros);
        window.location.assign(`/pages/gracias?${q}`);
        return;
      }

      if (res.ok) {
        // Éxito (2xx) pero sin una referencia usable en el cuerpo: puede
        // haber un pedido real ya registrado, así que no se debe decir que
        // falló. Como no hay número que mostrar, se le pide que guarde
        // evidencia y nos escriba, en vez de mandarlo a /pages/gracias con
        // un ref inválido.
        mostrarErrores({
          general:
            "Su pedido quedó registrado, pero no pudimos mostrarle el número de pedido. No lo envíe de nuevo: le llegará un WhatsApp con los datos de su pedido para que lo confirme.",
        });
        return;
      }

      mostrarErrores(cuerpo.errores ?? { general: "No pudimos registrar su pedido, intente de nuevo" });
    } catch {
      mostrarErrores({ general: "No pudimos conectar. Revise su internet e intente de nuevo." });
    } finally {
      boton.disabled = false;
      boton.textContent = textoPrevio;
    }
  }
}

// El píxel que instala la app de Facebook e Instagram de Shopify corre aislado
// y no se puede llamar desde el tema, así que aquí se carga el mismo píxel solo
// para los avisos del formulario. No manda PageView (las visitas ya las cuenta
// el de Shopify, y disablePushState evita que las mande si cambia la dirección)
// y va sin autoConfig para que no mande clics por su cuenta.
let pixelIniciado = false;
function pixelMeta(id) {
  if (!window.fbq) {
    const fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    fbq.disablePushState = true;
    window.fbq = fbq;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }
  if (!pixelIniciado) {
    window.fbq("set", "autoConfig", false, id);
    window.fbq("init", id);
    pixelIniciado = true;
  }
  return window.fbq;
}

// localStorage puede lanzar con solo leerlo (modo privado o datos bloqueados).
function almacenLocal() {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

// La atribución nunca hace fallar un pedido: si algo falla (cookies malformadas,
// lectura de document.cookie, etc.) devolvemos solo la página.
function atribucionSegura(atribucion) {
  try {
    return cuerpoAtribucion(atribucion, location.origin + location.pathname, document.cookie);
  } catch {
    return { pagina: location.origin + location.pathname };
  }
}
